/**
 * Centralized path definitions for the application.
 * Using a constant object ensures that URLs are typed and consistent
 * across the codebase, making it easier to manage navigation and refactor routes.
 */
export const paths = {
  dashboard: '/',
  planet: {
    list: '/planets',
    detail: (id: string) => `/planets/${id}`,
  },
  transaction: {
    list: '/transactions',
    detail: (id: string) => `/transactions/${id}`,
  },
  users: {
    list: '/users',
    detail: (id: string) => `/users/${id}`,
  },
  page403: '/error/403',
  page404: '/error/404',
  page500: '/error/500',
  offline: '/error/offline',
  docs: '/docs',
} as const;
